import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { APIGetResponse } from './types';
import { axiosBaseQuery } from './baseQuery';

const CHANNEL_PRODUCT_URL = `/api/channel-products`;

export const channelProductApi = createApi({
  reducerPath: 'channelProduct.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['channelProduct', 'channelProductOptionVariants', 'channelSupply'],
  endpoints: (builder) => ({
    getChannelProducts: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        productName = '',
        displayStatus = '',
        saleStatus = '',
        sort = '',
        supplyAllChannels = '',
      }) => ({
        url: `${CHANNEL_PRODUCT_URL}?pageNo=${pageNo}&pageSize=${pageSize}&productName=${productName}&displayStatus=${displayStatus}&saleStatus=${saleStatus}&sort=${sort}&supplyAllChannels=${supplyAllChannels}`,
      }),
      transformResponse: (response, meta: any): APIGetResponse => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['channelProduct'],
    }),
    getChannelProductById: builder.query({
      query: (id) => ({
        url: `${CHANNEL_PRODUCT_URL}/${id}`,
      }),
      providesTags: ['channelProduct'],
    }),
    addChannelProduct: builder.mutation({
      query: (body) => ({
        url: `${CHANNEL_PRODUCT_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['channelProduct'],
    }),
    updateChannelProduct: builder.mutation({
      query: (body) => ({
        url: `${CHANNEL_PRODUCT_URL}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['channelProduct', 'channelSupply'],
    }),
    deleteChannelProduct: builder.mutation({
      query: (id) => ({
        url: `${CHANNEL_PRODUCT_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['channelProduct'],
    }),
    getChannelProductOptionVarirants: builder.mutation({
      query: (body) => ({
        url: `${CHANNEL_PRODUCT_URL}/filter-option-variants`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['channelProductOptionVariants'],
    }),
    addChannelProductWish: builder.mutation<void, number>({
      query: (channelProductId) => ({
        url: `${CHANNEL_PRODUCT_URL}/${channelProductId}/wish`,
        method: 'POST',
      }),
      invalidatesTags: ['channelProduct'],
    }),
    removeChannelProductWish: builder.mutation<void, number>({
      query: (channelProductId) => ({
        url: `${CHANNEL_PRODUCT_URL}/${channelProductId}/wish`,
        method: 'DELETE',
      }),
      invalidatesTags: ['channelProduct'],
    }),
  }),
});

export const {
  useGetChannelProductsQuery,
  useGetChannelProductByIdQuery,
  useAddChannelProductMutation,
  useGetChannelProductOptionVarirantsMutation,
  useUpdateChannelProductMutation,
  useDeleteChannelProductMutation,
  useAddChannelProductWishMutation,
  useRemoveChannelProductWishMutation,
} = channelProductApi;
